import script from "./VSanta.vue?vue&type=script&setup=true&lang=ts"
export * from "./VSanta.vue?vue&type=script&setup=true&lang=ts"

import "./VSanta.vue?vue&type=style&index=0&id=3e6bd47e&lang=scss"

const __exports__ = script;

export default __exports__